import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetBloodRelationResult } from './get-blood-relation.result';

export async function getGetBloodRelation(): Promise<GetBloodRelationResult[]> {
  const [error, res] = await tryCatch(HSApi.get<GetBloodRelationResult[]>(`/firms/blood-relation-definitions`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
